/**
 * CarImage Atom Component
 * Optimized image component for car photos
 */

import { cn } from '@/lib/utils'
import { Car as CarIcon } from 'lucide-react'
import Image from 'next/image'
import React from 'react'

interface CarImageProps {
	src: string
	alt: string
	fill?: boolean
	width?: number
	height?: number
	priority?: boolean
	className?: string
	objectFit?: 'contain' | 'cover'
}

export function CarImage({
	src,
	alt,
	fill = false,
	width,
	height,
	priority = false,
	className,
	objectFit = 'cover',
}: CarImageProps) {
	const [error, setError] = React.useState(false)

	if (error || !src) {
		return (
			<div
				className={cn(
					'flex items-center justify-center bg-gray-100',
					className
				)}
			>
				<CarIcon className='w-12 h-12 text-gray-400' />
			</div>
		)
	}

	return (
		<Image
			src={src}
			alt={alt}
			fill={fill}
			width={!fill ? width : undefined}
			height={!fill ? height : undefined}
			priority={priority}
			className={cn(
				objectFit === 'cover' ? 'object-contain' : 'object-contain',
				className
			)}
			onError={() => setError(true)}
		/>
	)
}
